import React from 'react'
import { SpinnerContainer, StyledSpinner } from './Spinner.styled'

export const BlockSpinner = ({ className }: { className?: string }) => (
  <SpinnerContainer className={className}>
    <StyledSpinner />
  </SpinnerContainer>
)
export { StyledSpinner as Spinner } from './Spinner.styled'
